import State from 'store/State';
import {
    buildBarRequest,
    MarketDataRequest,
} from 'marketData/MarketDataRequest';

import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';
import { buildIntraDayProfileConfigSlice } from 'widgets/intraDayProfile/store/configuration/configSlice';
import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import { initialIntraDayProfileConfiguration } from 'widgets/intraDayProfile/store/configuration/IntraDayProfileConfiguration';

const {
    selectors: { selectConfigState },
} = buildIntraDayProfileConfigSlice();

export function getIntradayProfileMarketDataRequests(
    portfolioSelection: PortfolioSelectionWrapper,
    widgetKey: string,
    appSettings: AppSettingsState,
    state: State
): MarketDataRequest[] {
    const symbol = portfolioSelection.selectedSymbol;

    // We only retrieve external market data for Intraday Profiles if there is a single symbol selection...
    if (!symbol) {
        return [];
    }

    const { bucketSize } =
        selectConfigState(state, widgetKey) ??
        initialIntraDayProfileConfiguration;

    return [buildBarRequest(symbol, portfolioSelection.symbology, bucketSize)];
}
